import { useState, useEffect, useRef } from "react";

// ==============================|| CONFIG - LOCAL STORAGE ||============================== //

export default function useLocalStorage<T>(
  key: string,
  defaultValue: T
): [React.MutableRefObject<T>, (newValue: object | (() => object)) => void] {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue === null ? defaultValue : JSON.parse(storedValue);
  });
  const _value = useRef(value);

  useEffect(() => {
    const listener = (e: StorageEvent) => {
      if (e.storageArea === localStorage && e.key === key) {
        _value.current = e.newValue ? JSON.parse(e.newValue) : e.newValue;
        setValue(_value);
      }
    };

    window.addEventListener("storage", listener);

    return () => {
      window.removeEventListener("storage", listener);
    };
  }, [key]);

  const setValueInLocalStorage = (newValue: object | (() => object)) => {
    setValue(() => {
      const current = typeof newValue === "function" ? newValue() : newValue;
      localStorage.setItem(key, JSON.stringify(current));
      _value.current = current;
      return _value;
    });
  };

  return [_value, setValueInLocalStorage];
}
